module.exports = __webpack_public_path__ + "static/media/bicycle.771d02b0.png";